 import { Injectable } from '@angular/core';
 import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { ItemGeneralListado } from '../../helpers/components/itemClasses/itemListadoGeneral.class';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/toPromise';
import { SxHttpService } from './sxHttp.service';
import { TipoSolicitud } from '../model/interfaces/tiposolicitud.interface';
import { ItemSolicitudesDisponiblesListado } from 'app/helpers/components/itemClasses/itemListadoSolicitudesDisponibles.class';

@Injectable()
export class TipoSolicitudService {
  private tipoSolicitudUrl = 'api/configuracionTipoSolicitud';

  constructor(private http: Http,
              private sxHttp: SxHttpService) { }


  getAllTipoSolicitud(): Observable<ItemGeneralListado[]> {
    const search = {};
    return this.http.get(this.tipoSolicitudUrl, search)
      .map(response => response.json().data as ItemGeneralListado[]);
  }

  getTipoSolicitudDetalle(codTipoSolicitud: string): Observable<TipoSolicitud> {
    return this.sxHttp.get(this.tipoSolicitudUrl + '/' + codTipoSolicitud)
      .map(response => response.json().data as TipoSolicitud);
  }

  /**
   * Obtiene la lista de tipos de Solicitud desde el backend y la mapea
   * a un formato compatible para el componente Listado General
   */
  getForList(): Observable<ItemGeneralListado[]> {

    return this.sxHttp.get('api/configuracionTipoSolicitud')
      .map(response => {
        return response.json().data.map(tiposolicitud => {
          return {
            id: tiposolicitud.codigo,
            Descripcion: tiposolicitud.subtitulo,
            Imagen: tiposolicitud.urlImage,
            Titulo: tiposolicitud.titulo
          };
        }) as ItemGeneralListado[];
      });
  }

  /**
   * Obtiene la lista de tipos de Solicitud desde el backend y la mapea
   * a un formato compatible para el componente Listado General
   */
  getDisponiblesForList(): Observable<ItemSolicitudesDisponiblesListado[]> {

    return this.sxHttp.get('api/configuracionTipoSolicitud')
      .map(response => {
        return response.json().data.map(tiposolicitud => {
          return {
            Codigo: tiposolicitud.codigo,
            Titulo: tiposolicitud.titulo,
            Descripcion: tiposolicitud.subtitulo,
            Imagen: tiposolicitud.imagen,
            Icono: 'auto',
            UtilizadoEnNivel: false,
          };
        }) as ItemSolicitudesDisponiblesListado[];
    });
  }

  /**
   * Edita un negocio existente el backend
   */
  editar(datos: TipoSolicitud): Promise<TipoSolicitud> {
    delete datos['completitud'];
    return this.sxHttp.put('api/configuracionTipoSolicitud/', datos)
      .toPromise()
      .then(response => response.json().data as TipoSolicitud);
  }

  crear(tiposolicitud: TipoSolicitud) {
    return this.sxHttp.post('api/configuracionTipoSolicitud/', tiposolicitud)
        .toPromise()
        .then(response => response.json().data as TipoSolicitud);
  }

  insertOrDeleteLevel(codTiposolicitud: String, sistemasUrl : String , negocioUrl : String, productoUrl : String): Promise<String> {
    if (productoUrl != null && productoUrl !== '' && productoUrl !== undefined) {
      return this.sxHttp
      .put(this.tipoSolicitudUrl + '/InsertarEliminar/' + codTiposolicitud + '/' + sistemasUrl + '/' + negocioUrl + '/' + productoUrl, null)
      .toPromise()
      .then(response => response.json().data as String);
    } else {
      return this.sxHttp.put(this.tipoSolicitudUrl + '/InsertarEliminar/' + codTiposolicitud + '/' + sistemasUrl + '/' + negocioUrl, null)
      .toPromise()
      .then(response => response.json().data as String);
    }
  }

  getByLevel(sistemasUrl: string , negocioUrl: string, productoUrl: string ): Observable<ItemGeneralListado[]> {
    const search = {};

    if (productoUrl !== null && productoUrl !== '' && productoUrl !== undefined) {
        return this.sxHttp.get(this.tipoSolicitudUrl + '/nivel/' + sistemasUrl + '/' + negocioUrl + '/' + productoUrl, search )
        .map(TipoSolicitudService.mapResponseToItemGeneral);
    } else {
        return this.sxHttp.get(this.tipoSolicitudUrl + '/nivel/' + sistemasUrl + '/' + negocioUrl, search )
        .map(TipoSolicitudService.mapResponseToItemGeneral);
    }
  }

  // tslint:disable-next-line:member-ordering
  private static mapResponseToItemGeneral(response: Response) : ItemGeneralListado[]{
    if (!response.json().data) {
      return [];
    }

    return response.json().data.map(tiposolicitud => {
      return {
        id: tiposolicitud.codigo,
        Titulo: tiposolicitud.descripcion,
        Descripcion: tiposolicitud.descripcionExt,
        Imagen: tiposolicitud.imagen,
        TipoEntidadRelacionaria: tiposolicitud.tipoEntidadRelacionaria,
        CategoriaUsuaria: tiposolicitud.categoriaUsuaria
      };
    }) as ItemGeneralListado[];
  }
}


// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/infrastructure/services/tiposolicitud.service.ts